export default {
  en: {
    title: 'Rail Listings',
    listingsTitle: 'Available Buses',
    changeButton: 'Change',
    filterTitle: 'Filter',
    allTransports: 'All Transports',
    transport: 'Transport',
    transports: 'Transports',
    stops: 'Stops',
    stop: 'Stop',
    price: 'Price',
    listings: 'listings',
    departure: 'Departure',
    arrival: 'Arrival',
    return: 'Return',
    book: 'Book Ride',
    cheapest: 'Cheapest',
    expensive: 'Expensive',
    emptyMessage: 'No matches for your search',
    startingPrice: 'Starting Price',
    ride: 'Ride',
    rides: 'Rides',
    rideListing: 'Ride Listing',
    ridesListing: 'Rides Listings',
    seeMore: 'See more',
    fareRule: {
      title: 'Terms and Conditions',
      text: 'To continue. You have to agree with these statutes',
      acceptButton: 'I Accept',
    },
    totalAmount: 'Total Amount',
    ticketFare: 'Ticket Fare',
    serviceFee: 'Service Fee',
    returnFare: 'Return Fare',
    departureFare: 'Departure Fare',
    billingBreakdown: 'Billing Breakdown',
  },
  fr: {
    title: 'Annonces ferroviaires',
    listingsTitle: 'Autobus disponibles',
    changeButton: 'Changer',
    filterTitle: 'Filtrer',
    allTransports: 'Tous les transports',
    transport: 'Transport',
    transports: 'Transports',
    stops: 'Arrêts',
    stop: 'Arrêt',
    price: 'Prix',
    listings: 'listings',
    departure: 'Départ',
    arrival: 'Arrivée',
    return: 'Retour',
    book: 'Carrousel de livres',
    cheapest: 'Le moins cher',
    expensive: 'Plus cher',
    view: 'Voir les détails',
    emptyMessage: 'Aucune correspondance pour votre recherche',
    startingPrice: 'Prix de départ',
    ride: 'Trajet',
    rides: 'Trajets',
    rideListing: 'Liste des manèges',
    ridesListing: 'Listes de manèges',
    seeMore: 'Voir plus',
    fareRule: {
      title: 'Conditions générales',
      text: 'Pour continuer. Vous devez accepter ces statuts',
      acceptButton: 'J\'accepte',
    },
    totalAmount: 'Montant total',
    ticketFare: 'Tarif du billet',
    serviceFee: 'Frais de service',
    returnFare: 'Tarif de retour',
    departureFare: 'Tarif de départ',
    billingBreakdown: 'Ventilation de la facturation',
  },
  sp: {
    title: 'Listados de trenes',
    listingsTitle: 'Vuelo disponible',
    changeButton: 'CambiarCambiar',
    filterTitle: 'Filtrar',
    allTransports: 'Todos los transportes',
    transport: 'Transporte',
    transports: 'Transportes',
    stops: 'Paradas',
    stop: 'Parada',
    price: 'Precio',
    listings: 'listados',
    departure: 'Salida',
    arrival: 'Llegada',
    return: 'Regreso',
    book: 'Paseo del libro',
    cheapest: 'Más barato',
    expensive: 'Más caro',
    emptyMessage: 'No hay resultados para su búsqueda',
    startingPrice: 'Precio inicial',
    ride: 'Ir a',
    rides: 'Viajes',
    rideListing: 'Listado de paseos',
    ridesListing: 'Listado de paseos',
    seeMore: 'Ver más',
    fareRule: {
      title: 'Términos y condiciones',
      text: 'Para continuar. Tienes que estar de acuerdo con estos estatutos',
      acceptButton: 'Acepto',
    },
    totalAmount: 'Importe total',
    ticketFare: 'Tarifa del billete',
    serviceFee: 'Tarifa de servicio',
    returnFare: 'Tarifa de ida y vuelta',
    departureFare: 'Tarifa de salida',
    billingBreakdown: 'Desglose de la facturación',
  },
  sw: {
    title: 'Orodha za Reli',
    listingsTitle: 'Mabasi Yanayopatikana',
    changeButton: 'Badilika',
    filterTitle: 'Chuja',
    allTransports: 'Usafiri Wote',
    transport: 'Usafiri',
    transports: 'Usafirishaji',
    stops: 'Inasimama',
    stop: 'Acha',
    price: 'Bei',
    listings: 'orodha',
    departure: 'Kuondoka',
    arrival: 'Kuwasili',
    return: 'Rudi',
    book: 'Book Ride',
    cheapest: 'Nafuu zaidi',
    expensive: 'Ghali',
    view: 'Tazama Maelezo',
    layover: 'Layover',
    emptyMessage: 'Hakuna zinazolingana na utafutaji wako',
    startingPrice: 'Bei ya Kuanzia',
    ride: 'Panda',
    rides: 'Wapanda',
    rideListing: 'Orodha ya wapanda farasi',
    ridesListing: 'Orodha ya wapanda farasi',
    seeMore: 'Ona zaidi',
    fareRule: {
      title: 'Masharti na Masharti',
      text: 'Ili kuendelea. Lazima ukubaliane na sheria hizi',
      acceptButton: 'Nakubali',
    },
    totalAmount: 'Jumla',
    ticketFare: 'Nauli ya Tiketi',
    serviceFee: 'Ada ya Huduma',
    returnFare: 'Nauli ya Kurudi',
    departureFare: 'Nauli ya Kuondoka',
    billingBreakdown: 'Uchanganuzi wa Malipo',
  },
};
